// Client-side participation status metadata, shared by the admin page and the
// public choropleth. Status keys + colors are the contract with the server
// (server/services/participation-status.js and theme.participationColors); the
// labels here are the single place the human-readable copy lives. Order is the
// funnel order used for the admin summary strip and the map legend.
export const PARTICIPATION_STATUS_ORDER = Object.freeze([
  'active_quote',
  'committed',
  'interest_not_expressed',
]);

export const PARTICIPATION_STATUS_LABELS = Object.freeze({
  active_quote: 'Active Quote',
  committed: 'Committed',
  interest_not_expressed: 'Interest Not Yet Expressed',
});

export const DEFAULT_PARTICIPATION_STATUS = 'interest_not_expressed';

export const participationLabel = (status) => PARTICIPATION_STATUS_LABELS[status]
  ?? PARTICIPATION_STATUS_LABELS[DEFAULT_PARTICIPATION_STATUS];
